import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminPanel() {

    const navigate = useNavigate();

  return (
    <div className="admin-controls">
      <h3>Admin Panel</h3>
      <div className="admin-actions">
        <button className="add-station" onClick={() => navigate('/adminStations')}>Přidat ČS</button>
        <button className="manage-users" onClick={() => navigate('/adminUsers')}>Uživatelé</button>
        <button className="view-logs" onClick={() => navigate("/emailLogs")}>Email logy</button>
      </div>
    </div>
  );
}